export default "__VITE_ASSET__C9Yx5KgP__"